export function moveInArray<T>(array: T[], from: number, to: number): void {
  const item = array[from];
  array.splice(from, 1);
  array.splice(to, 0, item);
}
